import { DELETE_COUPON_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[DELETE_COUPON_MODAL_MODULE_ID]: {
		moduleType: 'modal',
		modalTitle: 'Delete Coupon',
		modalText: '',
	},
}
